import { render, staticRenderFns } from "./BetslipBetComboB.vue?vue&type=template&id=499833de&scoped=true"
import script from "./BetslipBetComboB.vue?vue&type=script&lang=js"
export * from "./BetslipBetComboB.vue?vue&type=script&lang=js"
import style0 from "./BetslipBetComboB.vue?vue&type=style&index=0&id=499833de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499833de",
  null
  
)

export default component.exports